import { render, staticRenderFns } from "./fppkNotification.vue?vue&type=template&id=7a81f06c&scoped=true"
import script from "./fppkNotification.vue?vue&type=script&lang=js"
export * from "./fppkNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a81f06c",
  null
  
)

export default component.exports